import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'admin/users',
  urlRoot: 'admin/users',

  state: {
    total: 0,
    manager: null,
    client: null
  },

  mutations: {
    setManager(state, manager) {
      state.manager = manager
    },

    setClient(state, client) {
      state.client = client
    }
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  actions: {
    linkClient(context, client) {
      return http.post('admin/setlinks/user', {
        clients: [client]
      })
    },

    linkManager(context, manager) {
      return http.post('admin/setlinks/user', {
        managers: [manager]
      })
    },

    async unlinkClient({ commit }, payload) {
      let response = await http.post('admin/unset/link/client', payload)

      commit('setClient', null)

      return response
    },

    async unlinkManager({ commit }, payload) {
      let response = await http.post('admin/unset/link/manager', payload)

      commit('setManager', null)

      return response
    }
  },

  parseSingle(response) {
    let { data } = response
    return Object.assign({}, response, {
      data: data.user ? data.user : data,
      manager: data.manager || null,
      client: data.client || null
    })
  },

  onFetchSingleSuccess(state, response) {
    state.manager = response.manager
    state.client = response.client
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  }
})

export default withDataFilter(store)
